import type {
  GroupMeetingClassTeacher,
  GroupMeetingClassTeacherDto,
  GroupMeetingClassTeachers,
  GroupMeetingClassTeachersDto,
} from "meetings/group-meeting/types";

const classTeacherFromDto = (
  dto: GroupMeetingClassTeacherDto,
): GroupMeetingClassTeacher => ({
  teacherId: dto.teacher_id,
  teacherShortage: dto.teacher_shortage,
  studentsTotal: dto.students_total,
  hasFeedback: dto.has_feedback,
});

export const groupMeetingClassTeachersFromDto = (
  dto: GroupMeetingClassTeachersDto,
): GroupMeetingClassTeachers =>
  Object.fromEntries(
    Object.entries(dto).map(([mentorClass, teachers]) => [
      mentorClass,
      teachers.map(classTeacherFromDto),
    ]),
  );
